import { PlanLimitConfigs, BillingCycleConfig } from "../types.ts";

export const JPD_DEFAULT_BILLING_CYCLE = "MONTHLY";
export const JPD_DEFAULT_UNIT_COUNT = 10;

export const JPD_MIN_ENTERPRISE_USER_COUNT = 201;

export const jpdOfferingSkus = {
    free: "jira-servicedesk-free", // jpd-free shares the same sku as jsm-free
    standard: "jira-product-discovery-standard",
    premium: "jira-product-discovery-premium-sku"
} as const;

export const jpdOfferingSkusArray = Object.values(jpdOfferingSkus);

export const jpdPlanLimitConfigs: PlanLimitConfigs[] = [
    {
        planName: "Free",
        offeringSku: jpdOfferingSkus.free,
        recommendationLimit: 0,
        signupLimit: 20_000
    },
    {
        planName: "Standard",
        offeringSku: jpdOfferingSkus.standard,
        recommendationLimit: 3,
        signupLimit: 20_000
    },
    {
        planName: "Premium",
        offeringSku: jpdOfferingSkus.premium,
        recommendationLimit: 50,
        signupLimit: 20_000
    }
];

export const jpdBillingCycleConfig: BillingCycleConfig = {
    monthly: true,
    annual: true
};
